import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import { LocalizationGroupSchema } from "./get-localization-groups";

export const createOrUpdateLocalizationGroup = {
  name: "createOrUpdateLocalizationGroup" as const,
  input: z.object({
    teamId: zExt.objectId(),
    id: zExt.objectId().optional(),
    name: z.string(),
    description: z.string(),
    countries: z.array(z.string()),
    languages: z.array(z.string()),
  }),
  output: z.object({ localizationGroup: LocalizationGroupSchema }),
};
